module.exports = __webpack_public_path__ + "img/zetachain-icon.0636c00d.png";